import { useQuery } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'
import { MarketShopOrderModel } from '@/models'

interface GetMarketShopRestaurantOrdersResponse {
  marketShopId: number
  orders: Array<MarketShopOrderModel>
}

export const getMarketShopRestaurantOrdersQueryKey = () => ['useGetMarketShopRestaurantOrders']

export const getMarketShopRestaurantOrders = async () => {
  const response =
    await marketShopAPI.get<GetMarketShopRestaurantOrdersResponse>(`/market-shop/orders`)
  return response.data
}

export const useGetMarketShopRestaurantOrders = () => {
  return useQuery({
    queryFn: () => getMarketShopRestaurantOrders(),
    queryKey: getMarketShopRestaurantOrdersQueryKey(),
  })
}
